import "materialize-css/dist/css/materialize.min.css";
import "./App.scss";

import * as React from "react";
import { Router, Route } from "react-router-dom";
import { Redirect, Switch } from "react-router-dom";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import firebase from "firebase/compat/app";
import ReactGA from "react-ga";

import { withAuthentication } from "./Session";
import { createBrowserHistory } from "history";
import { NotificationContainer } from "react-notifications";

import * as ROUTES from "./constants/routes";
import CreatePitchArt from "./Create/CreatePitchArt";
import PeldaView from "./Pelda/PeldaView";
import WordSyllableCategories from "./Learn/WordSyllableCategories";
import WordSyllableReview from "./Learn/WordSyllableReview";
import Home from "./Authentication/home";
import Landing from "./Authentication/landing";
import signUp from "./Authentication/signup";
import signIn from "./Authentication/login";
import signOut from "./Authentication/signout";
import TermsAndConditions from "./Authentication/TermsAndConditions";
import passwordForget from "./Authentication/password_forget";
import accountPage from "./Authentication/account";
import MyFiles from "./MyFiles/MyFiles";
import History from "./History/History";
import ManageUsers from "./Admin/ManageUsers";
import Collections from "./Pages/Collections";
import Converter from "./Converter/Converter";
import LearnNew from "./Pages/LearnNew";
import Feedback from "./Feedback/Feedback";
import Thankyou from "./Feedback/ThankYou";
import NotificationsComponent from "./Notifications/Notifications";
import TermsOfUseContent from "./Authentication/terms_of_use_content";
import DocumentationContent from "./Authentication/Documentation";
import { ThunkDispatch } from "redux-thunk";
import { AppActions } from "./store/appActions";
import { setCurrentUserRole } from "./store/userDetails/actions";
import { connect } from "react-redux";
import { AppState } from "./store";
import * as constants from "./constants";

const LazyTermsOfUseContent = React.lazy(() => import('./Authentication/terms_of_use_content'));

interface Props {
  firebase: any;
  currentUserRole:string;
  setCurrentUserRole:(role:string) =>void;
}

interface State {
  authUser: any;
}

const history = createBrowserHistory();

// ReactGA.initialize("UA-157894331-1");
// history.listen((location) => {
//   ReactGA.set({ page: location.pathname }); // Update the user's current page
//   ReactGA.pageview(location.pathname); // Record a pageview for the given page
// });

// const latencyPerformanceCallback = (list: any) => {
//   list.getEntries().forEach((entry: any) => {
//     ReactGA.timing({
//       category: "Load Performace",
//       variable: "Server Latency",
//       value: entry.responseStart - entry.requestStart,
//     });
//   });
// };
// const renderingPerformanceCallback = (list: any) => {
//   list.getEntries().forEach((entry: any) => {
//     if (entry.name.includes("App")) {
//       ReactGA.timing({
//         category: "App Render Performace",
//         variable: entry.name,
//         value: entry.duration,
//       });
//     }
//   });
// };

// const latencyPerformanceObserver = new PerformanceObserver(
//   latencyPerformanceCallback
// );
// latencyPerformanceObserver.observe({ entryTypes: ["navigation"] });

// const renderingPerformanceObserver = new PerformanceObserver(
//   renderingPerformanceCallback
// );
// renderingPerformanceObserver.observe({ entryTypes: ["mark", "measure"] });

const HomeGate = (props: any) => {
  const [ok, setOk] = React.useState<null | boolean>(null);

  // normalize email for doc id
  const emailKey = (u: firebase.User | null) =>
  u?.email ? u.email.trim().toLowerCase() : null; 
  
  React.useEffect(() => {
    const unsub = firebase.auth().onAuthStateChanged(async (user) => {
      if (!user) {
        setOk(false); // not signed in -> redirect to T&C (which will bounce to sign-in)
        return;
      }
      try {
        const db = firebase.firestore();

        // Latest T&C (order by currentTncVersion descending)
        const tncSnap = await db
          .collection("TermsAndConditions")
          .orderBy("currentTncVersion", "desc")
          .limit(1)
          .get({ source: "server" });

        const currentVersion = tncSnap.empty
          ? 1
          : Math.trunc(Number(tncSnap.docs[0].get("currentTncVersion")));

        // User's accepted version
        const userSnap = await db.doc(`users/${emailKey(user)}`).get({ source: "server" });
        const acceptedRaw = userSnap.exists ? userSnap.get("acceptedTncVersion") : undefined;
        const acceptedVersion = Math.trunc(Number(acceptedRaw));

        const isAccepted =
          Number.isFinite(currentVersion) &&
          Number.isFinite(acceptedVersion) &&
          acceptedVersion === currentVersion;

        setOk(isAccepted);
      } catch (e) {
        console.error("HomeGate check failed:", e);
        setOk(false);
      }
    });

    return () => unsub();
  }, []);

  if (ok === null) return null;

  // If accepted, render Home; else go to T&C
  return ok ? <Home {...props} /> : <Redirect to={ROUTES.TERMS_AND_CONDITIONS} />;
};

const App = () => (
  <Router history={history}>
    <div className="App">
      <NotificationContainer />
      <Route exact={true} path={ROUTES.LANDING} component={Landing} />
      <Route exact={true} path={ROUTES.SIGN_UP} component={signUp} />
      <Route exact={true} path={ROUTES.SIGN_IN} component={signIn} />
      <Route exact={true} path={ROUTES.TERMS_AND_CONDITIONS} component={TermsAndConditions} />
      <Route exact={true} path={ROUTES.HOME} component={HomeGate} />  
      <Route
        exact={true}
        path={ROUTES.PASSWORD_FORGET}
        component={passwordForget}
      />
      <Route path={ROUTES.TERMS_OF_USE} component={TermsOfUseContent}/>
      <Route exact={true} path={ROUTES.ACCOUNT} component={accountPage} />
      <Route exact={true} path={ROUTES.MY_FILES} component={MyFiles} />
      <Route exact={true} path={ROUTES.HISTORY} component={History} />
      <Route exact={true} path={ROUTES.SIGN_OUT} component={signOut} />
      <Route exact={true} path={ROUTES.COLLECTIONS} component={Collections} />
      <Route exact={true} path={ROUTES.CONVERTER} component={Converter} />
      <Route exact={true} path={ROUTES.FEEDBACK} component={Feedback} />
      <Route exact={true} path={ROUTES.THANKYOU} component={Thankyou}/>
      
      <Route exact={true} path={ROUTES.DOCUMENTATION} component={DocumentationContent} />
      {/* <Route exact path="/collections/:id" component={LearnNew} /> */}
      <Route exact path="/learnnew/:collection/:id" component={LearnNew} />
      <Route path="/manage-users" component={ManageUsers} />
      <Route path="/pitchartwizard/:type?/:id?" component={CreatePitchArt} />
      <Route path="/peldaview" component={PeldaView} />
      <Route path="/learn/words/syllables" component={WordSyllableCategories} />
      <Route
        path="/learn/words/syllables/:numSyllables"
        component={WordSyllableReview}
      />
      <Route path={ROUTES.NOTIFICATIONS} component={NotificationsComponent}/>
    </div>
  </Router>
);

const mapStateToProps = (state: AppState) => ({
  currentUserRole: state.userDetails.currentUserRole
  
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AppActions>
) => ({
  setCurrentUserRole:(role:string) => dispatch(setCurrentUserRole(role)),
 
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthentication(App as any));